import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { deleteFromWeatherList } from '../data/actions/weatherMutatorActions';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./WeatherLocations.scss');

export interface WeatherLocationRowProps {
    index: number;
    rowTextValue: string;
    disabled: boolean;
}

/**
 * Functional component for displaying a row in the weather location settings page for existing
 * locations
 * @param props
 */
export default function WeatherLocationRow(props: WeatherLocationRowProps) {
    const { index, rowTextValue, disabled } = props;
    return (
        <div className={styles.weatherLocationRowContainer}>
            <span className={styles.weatherLocationRowSpan}>{rowTextValue}</span>
            <IconButton
                className={styles.deleteWeatherLocationButton}
                key="delete"
                iconProps={{ iconName: ControlIcons.Delete }}
                onClick={deleteButtonClicked(index)}
                disabled={disabled}
                title={strings.options_weather_removeLocationTitle}
            />
        </div>
    );
}

function deleteButtonClicked(index: number): () => void {
    return () => {
        deleteFromWeatherList(index);
    };
}
